import { ComponentProps } from 'react';
import dynamic from 'next/dynamic';

import { Accordion as SpAccordion } from './index.dev.js'
import { AccordionItem as SpAccordionItem } from './index.dev.js'

export const Accordion = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpAccordion,
        ComponentProps<typeof SpAccordion>
    >
>(() => import('./index.dev.js').then(({ Accordion }) => Accordion), {
    ssr: false,
});
export const AccordionItem = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpAccordionItem,
        ComponentProps<typeof SpAccordionItem>
    >
>(() => import('./index.dev.js').then(({ AccordionItem }) => AccordionItem), {
    ssr: false,
});
